import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EndUserForm from '../../../booking/components/end_user/EndUserForm';
import { bindActionCreators } from 'redux';
import { submitEndUser, cancel, submitClientData } from '../../../../data/booking/actions/booking';
import { normalizeEndUser, normalizeClientData } from '../../../../data/booking/normalizers/end_user';
import { getEndUser, getEditingEndUser } from '../../../../data/booking/selectors/booking';
import { getValues } from '../../../../data/booking/selectors/end_user_form';

class EndUserFormContainer extends Component {
    static propTypes = {
        initialValues: PropTypes.object,
        submitEndUser: PropTypes.func,
        submitClientData: PropTypes.func,
        cancel: PropTypes.func,
        isEditing: PropTypes.bool
    };

    handleSubmit(values) {
        this.props.submitEndUser(normalizeEndUser(values));
        this.props.submitClientData(normalizeClientData(values));
    }



    handleClickCancel() {
        this.props.cancel();
    }

    render() {
        const { initialValues, isEditing } = this.props;
        return (
            <EndUserForm
                isEditing={isEditing}
                initialValues={initialValues}
                enableReinitialize={true}
                handleSubmit={::this.handleSubmit}
                onClickCancel={::this.handleClickCancel}
            />
        );
    }
}

export default connect(
    state => ({
        initialValues: getValues(state.booking),
        isEditing: getEditingEndUser(state.booking)
    }),
    dispatch => bindActionCreators({ submitEndUser, cancel, submitClientData }, dispatch)
)(EndUserFormContainer);
